import { PolymerElement, html } from '@polymer/polymer/polymer-element.js';
import '@polymer/paper-dropdown-menu/paper-dropdown-menu.js';
import '@polymer/paper-item/paper-item.js';
import { mixinBehaviors } from '@polymer/polymer/lib/legacy/class';
import { DefaultComputedBindings } from '../../../modules/DefaultComputedBindings.js';
import '@polymer/paper-listbox/paper-listbox.js';
import '../../katapult-dialog-legacy/katapult-dialog-legacy.js';
import { KatapultWidget } from './katapult-widget';
import { DateTime } from 'luxon';
import '../../katapult-auth/katapult-auth.js';
import '../../katapult-toolbar/katapult-toolbar.js';
import 'iron-a11y-keys/iron-a11y-keys.js';
import { ToArray } from '../../../modules/ToArray.js';
import { Download } from '../../../modules/Download.js';

class StopwatchWidget extends mixinBehaviors([DefaultComputedBindings], KatapultWidget) {
  static get widgetTitleTemplate() {
    return html`<span>Stopwatch</span> `;
  }
  static get widgetHeaderContent() {
    return html`
      <style>
        span {
          flex-grow: 3;
        }
      </style>
      <span class="headerPiece"></span>
    `;
  }
  static get headerTemplate() {
    return html`<span>Stopwatch</span>`;
  }
  static get headerEndTemplate() {
    return html``;
  }

  static get primaryControlTemplate() {
    return html`
    <style>
      paper-item:hover{  
        background-color: #BEBEBE;
      }
    </style>
    <!-- Menu to select auto stop timer -->
    <paper-dropdown-menu id="ddmenu"  label="Auto Stop Timer" vertical-offset="60" on-iron-select="selectedItem">
        <paper-listbox slot="dropdown-content" class="dropdown-content" selected="5">
          <paper-item>15 minutes</paper-item>
          <paper-item>30 minutes</paper-item>
          <paper-item>45 minutes</paper-item>
          <paper-item>60 minutes</paper-item>
        </paper-listbox>
      </paper-menu>
    </paper-dropdown-menu>
    `;
  }
  static get bodyTemplate() {
    return html`
      <style include="paper-table-style katapult-scrollbars">
        /* :host { } */
        .elementBody {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          width: 100%;
          height: 500px;
        }
        button {
          outline: none;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          align-items: center;
          width: 20vh;
          height: 20vh;
          background: var(--paper-green-500);
          border: none;
          border-radius: 999px;
          border-bottom: 10px solid var(--paper-green-900);
          cursor: pointer;
          transition: all 0.1s ease;
          margin: 10px;
        }
        button[red] {
          background: var(--paper-red-500);
          border-bottom-color: var(--paper-red-900);
        }
        button:hover {
          transform: scale(0.99) translateY(2px);
        }
        button:active {
          transform: scale(0.97) translateY(6px);
          border-bottom-width: 4px;
        }
        button .title {
          color: rgba(0 0 0 / 50%);
          font-size: 36px;
          text-transform: uppercase;
          font-weight: bold;
          user-select: none;
          -webkit-user-select: none; /* Safari */
        }
        button .subtitle {
          color: rgba(0 0 0 / 50%);
          font-size: 32px;
          user-select: none;
          -webkit-user-select: none; /* Safari */
        }
        .deleteButton,
        .detailsButton {
          user-select: none;
          -webkit-user-select: none; /* Safari */
          color: var(--primary-text-color-faded);
          transition: all 0.2s ease;
        }
        .deleteButton:hover {
          color: var(--paper-red-500);
        }
        .detailsButton:hover {
          color: var(--secondary-color);
        }
        .export {
          margin: 5px;
        }
        paper-table {
          width: 100%;
        }
        paper-table-scroll {
          overflow-y: scroll;
          min-height: 150;
          max-height: 150px;
        }
        paper-cell {
          justify-content: center;
        }
      </style>
      <iron-a11y-keys id="a11y" target="[[this]]" keys="'" on-keys-pressed="updateStopwatchData"> </iron-a11y-keys>
      <div class="elementBody">
        <div class="elementBody" onload="focus1">
          <button id="button" red$="[[started]]" on-click="updateStopwatchData">
            <div class="title" hidden$="[[started]]">Start</div>
            <div class="title" hidden$="[[!started]]">Stop</div>
            <div class="subtitle">[[time]]</div>
          </button>
          <paper-table outline dividers rounded>
            <paper-row header>
              <paper-cell>Project</paper-cell>
              <paper-cell>Date</paper-cell>
              <paper-cell>Duration</paper-cell>
              <paper-cell>Notes</paper-cell>
              <paper-cell icon></paper-cell>
              <paper-cell icon></paper-cell>
            </paper-row>
            <paper-table-scroll enable>
              <template is="dom-repeat" items="[[records]]" as="record" sort="sortByStart">
                <paper-row slot="sortable">
                  <paper-cell>[[record.project]]</paper-cell>
                  <paper-cell>[[toDateString(record.stopped)]]</paper-cell>
                  <paper-cell>[[calcDuration(record)]]</paper-cell>
                  <paper-cell>[[record.notes]]</paper-cell>
                  <paper-cell icon ripple pointer class="detailsButton" on-click="promptForBucketData">
                    <material-icon icon="more_horiz"></material-icon>
                  </paper-cell>
                  <paper-cell icon ripple pointer class="deleteButton" on-click="promptDeleteRecord">
                    <material-icon icon="delete"></material-icon>
                  </paper-cell>
                </paper-row>
              </template>
            </paper-table-scroll>
          </paper-table>
          <katapult-button class="export" color="var(--secondary-color)" on-click="promptExport">Export Data</katapult-button>
        </div>
        <katapult-dialog-legacy id="bucketDataDialog" style="width: 600px;">
          <span slot="title">Bucket Data</span>
          <div slot="body">
            <paper-input
              label="Start Time"
              type="datetime-local"
              value="[[bucket._start_datetime]]"
              data-bucket-prop="_start_datetime"
              on-value-changed="updateBucketProp"
            ></paper-input>
            <paper-input
              label="End Time"
              type="datetime-local"
              value="[[bucket._end_datetime]]"
              data-bucket-prop="_end_datetime"
              on-value-changed="updateBucketProp"
            ></paper-input>
            <katapult-drop-down
              label="Project"
              items="[[userTimeClasses]]"
              label-path="description"
              value-path="description"
              value="[[bucket.project]]"
              data-bucket-prop="project"
              on-selected-changed="updateBucketProp"
            ></katapult-drop-down>
            <paper-textarea
              label="Notes"
              value="[[bucket.notes]]"
              data-bucket-prop="notes"
              on-value-changed="updateBucketProp"
            ></paper-textarea>
          </div>
          <katapult-button slot="buttons" dialog-dismiss>Cancel</katapult-button>
          <katapult-button slot="buttons" color="var(--paper-green-500)" hidden$="[[!_lastBucket]]" on-click="fillWithLast"
            >Fill with Last</katapult-button
          >
          <katapult-button color="var(--secondary-color)" slot="buttons" on-click="updateBucketData">Save</katapult-button>
        </katapult-dialog-legacy>
        <katapult-dialog-legacy id="deleteConfirmationDialog" style="width: 400px;">
          <span slot="title">Confirm Delete</span>
          <div slot="body">
            <p>Are you sure you want to delete this time bucket?</p>
          </div>
          <katapult-button slot="buttons" dialog-dismiss>Cancel</katapult-button>
          <katapult-button slot="buttons" color="var(--paper-red-500)" on-click="deleteRecord">Delete</katapult-button>
        </katapult-dialog-legacy>

        <katapult-dialog-legacy id="tooMuchTime" style="width: 400px;">
          <span slot="title">Are you still there?</span>
          <div slot="body">
            <p>Did you forget to stop me?</p>
          </div>
          <katapult-button slot="buttons" on-click="areYouThere">No, still working</katapult-button>
          <katapult-button slot="buttons" color="var(--paper-red-500)" on-click="updateStopwatchData">Yes, stop stopwatch</katapult-button>
        </katapult-dialog-legacy>

        <katapult-dialog-legacy id="exportDialog">
          <span slot="title">Export Data</span>
          <div slot="body">
            <paper-input
              disabled="[[!equal(exportRange, 'Custom')]]"
              label="Start Time"
              value="[[exportStartTime]]"
              type="datetime-local"
              data-prop="exportStartTime"
              on-value-changed="updateProp"
            ></paper-input>
            <paper-input
              disabled="[[!equal(exportRange, 'Custom')]]"
              label="End Time"
              value="[[exportEndTime]]"
              type="datetime-local"
              data-prop="exportEndTime"
              on-value-changed="updateProp"
            ></paper-input>
          </div>
          <katapult-button slot="buttons" color="var(--secondary-color)" on-click="exportData">Export</katapult-button>
        </katapult-dialog-legacy>
      </div>
    `;
  }

  static get is() {
    return 'katapult-stopwatch';
  }

  static get properties() {
    return {
      _lastBucket: {
        type: Object,
        value: null
      },
      bucket: {
        type: Object,
        value: {}
      },
      exportRange: {
        type: String,
        value: 'Custom'
      },
      exportRanges: {
        type: Array,
        value: ['This Week', 'Last Week', 'This Month', 'Last Month', 'Custom']
      },
      started: {
        type: String,
        value: null
      },
      astime: {
        type: String,
        value: '10:00:00'
      },
      timeOfLastInput: {
        type: String,
        value: null
      }
    };
  }

  static get observers() {
    return ['createStopwatchListener(user.uid, userGroup)', 'loadTimeClassesModels(user.uid, userGroup)'];
  }

  static get importMeta() {
    return import.meta;
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearInterval(this.timeInterval);
    clearInterval(this.autoStop);
  }

  ready() {
    super.ready();
  }

  calcDuration(record) {
    return DateTime.fromISO(record.stopped).diff(DateTime.fromISO(record.started)).toFormat('hh:mm:ss');
  }

  createStopwatchListener() {
    // Short-circuit if we are missing key user id data
    if (!this.userGroup || !this.user.uid) return;
    //Otherwise, get the stopwatch listener
    FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/user_data/${this.user.uid}/stopwatch`).on('value', (s) => {
      // Update data values
      this.started = s.val()?.started;
      this.records = ToArray(s.val()?.records || {});

      // If we are running
      if (!!this.started) {
        // Make sure we have cleared any existing intervals
        clearInterval(this.timeInterval);
        // Start the interval display
        this.timeInterval = setInterval(() => {
          this.time = DateTime.now().diff(DateTime.fromISO(this.started)).toFormat('hh:mm:ss');
        }, 1000);
      }
      // Otherwise, clear the interval and reset to zeroes
      else {
        clearInterval(this.timeInterval);
        this.time = '00:00:00';
      }
    });
  }

  deleteRecord(e) {
    FirebaseWorker.ref(
      `photoheight/company_space/${this.userGroup}/user_data/${this.user.uid}/stopwatch/records/${this.recordKeyToDelete}`
    ).set(null);
    this.recordKeyToDelete = null;
    this.shadowRoot.getElementById('deleteConfirmationDialog').close();
  }

  async exportData(e) {
    // Get user data from firebase
    let records = await FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/user_data/${this.user.uid}/stopwatch/records`)
      .once('value')
      .then((s) => s.val());

    // Output will be temporarily stored in array form
    let output = [['Project', 'Notes', 'Duration', 'Entered Start Time', 'Entered End Time', 'Actual Start Time', 'Actual Stop Time']];

    // Get the extents of the export
    let startMillis = DateTime.fromISO(this.exportStartTime).toMillis();
    let endMillis = DateTime.fromISO(this.exportEndTime).toMillis();

    for (const recordId in records) {
      const record = records[recordId];
      let recEndMillis = DateTime.fromISO(record.stopped).toMillis();
      // If the record's end time is outside of the export range, ignore this record
      if (recEndMillis < startMillis || recEndMillis > endMillis) continue;
      // Otherwise, add it to the export
      output.push([
        record.project,
        record.notes,
        this.calcDuration(record),
        this.toDateTimeString(record.started),
        this.toDateTimeString(record.stopped),
        this.toDateTimeString(record._started),
        this.toDateTimeString(record._stopped)
      ]);
    }

    // Finally, download the data (stringified first)
    Download(output.map((row) => row.join(',')).join('\n'), 'StopwatchExport.csv');
  }

  fillWithLast(e) {
    // Fill dialog form with data from last bucket
    this.set('bucket.project', this._lastBucket.project);
    this.set('bucket.notes', this._lastBucket.notes);
  }

  promptDeleteRecord(e) {
    this.recordKeyToDelete = e.model.record.$key;
    this.shadowRoot.getElementById('deleteConfirmationDialog').open();
  }

  promptExport(e) {
    this.shadowRoot.getElementById('exportDialog').open();
  }

  promptForBucketData(e) {
    let bucketId;
    // Get the bucket ID from the parameter
    if (typeof e == 'string') bucketId = e;
    else bucketId = e.model.record.$key;

    // Get deep copy of bucket data
    let tempBucket = JSON.parse(JSON.stringify(this.records.find((x) => x.$key == bucketId)));
    tempBucket._start_datetime = tempBucket.started.slice(0, 19);
    tempBucket._end_datetime = tempBucket.stopped.slice(0, 19);
    this.set(`bucket`, tempBucket);

    // Open the dialog
    this.shadowRoot.getElementById('bucketDataDialog').open();
  }

  sortByStart(a, b) {
    return DateTime.fromISO(b.started) - DateTime.fromISO(a.started);
  }

  toDateTimeString(isoTimestamp) {
    return DateTime.fromISO(isoTimestamp).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS).replace(',', '');
  }
  toDateString(isoTimestamp) {
    return DateTime.fromISO(isoTimestamp).toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY).replace(',', '');
  }

  async updateBucketData(e) {
    await FirebaseWorker.ref(
      `photoheight/company_space/${this.userGroup}/user_data/${this.user.uid}/stopwatch/records/${this.bucket.$key}`
    ).update({
      started: DateTime.fromISO(this.bucket._start_datetime).toISO(),
      stopped: DateTime.fromISO(this.bucket._end_datetime).toISO(),
      project: this.bucket.project || null,
      notes: this.bucket.notes || null
    });
    this._lastBucket = JSON.parse(JSON.stringify(this.bucket));
    this.shadowRoot.getElementById('bucketDataDialog').close();
  }

  async updateBucketProp(e) {
    let prop = e.currentTarget.dataset.bucketProp;
    this.set(`bucket.${prop}`, e.detail.value);
  }

  updateProp(e) {
    this[e.currentTarget.dataset.prop] = e.detail.value;
  }

  async updateStopwatchData() {
    clearInterval(this.autoStop);
    this.shadowRoot.getElementById('tooMuchTime').close();
    this.beep();
    this.getDatabase();
    this.timeOfLastInput = DateTime.now().toISO();
    // If we have just stopped the stopwatch, save the data to firebase
    if (this.started) {
      let bucket = await FirebaseWorker.ref(
        `photoheight/company_space/${this.userGroup}/user_data/${this.user.uid}/stopwatch/records`
      ).push({
        started: this.started,
        stopped: this.timeOfLastInput,
        _started: this.started,
        _stopped: this.timeOfLastInput
      });
      // Delete the active entry
      FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/user_data/${this.user.uid}/stopwatch/started`).set(null);
      // Prompt for additional data
      this.promptForBucketData(bucket.key);
    }
    // If we have just started the stopwatch, update firebase (to start the timer)
    else if (!this.started) {
      FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/user_data/${this.user.uid}/stopwatch/started`).set(
        this.timeOfLastInput
      );
      this.areYouThere();
    }
  }

  // Function that creates and controls the sound for the button press and  autostop
  beep(duration, frequency, volume, type, callback) {
    var audioCtx = new (window.AudioContext || window.webkitAudioContext || window.audioContext)();
    var oscillator = audioCtx.createOscillator();
    var gainNode = audioCtx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioCtx.destination);

    if (volume) {
      gainNode.gain.value = volume;
    }
    if (frequency) {
      oscillator.frequency.value = frequency;
    }
    if (type) {
      oscillator.type = type;
    }
    if (callback) {
      oscillator.onended = callback;
    }

    oscillator.start(audioCtx.currentTime);
    oscillator.stop(audioCtx.currentTime + (duration || 500) / 1000);
  }

  // Gets user group and user from the database
  getDatabase() {
    this.userGroup = document.querySelector('katapult-home').userGroup;
    this.user = document.querySelector('katapult-home').user;
  }

  // Listener for timer dropdown menu
  selectedItem(e) {
    var selectedItem = e.target.selectedItem;
    let selected = selectedItem.innerText;
    switch (selected) {
      case '15 minutes':
        this.astime = '00:15:00';
        break;
      case '30 minutes':
        this.astime = '00:30:00';
        break;
      case '45 minutes':
        this.astime = '00:45:00';
        break;
      case '60 minutes':
        this.astime = '01:00:00';
        break;
      default:
        this.astime = '06:00:00';
    }
  }

  // function that controls the auto stop timer functionality
  areYouThere() {
    this.shadowRoot.getElementById('tooMuchTime').close();
    this.startTimer = DateTime.now();
    this.autoStop = setInterval(() => {
      this.stopTimer = DateTime.now().diff(DateTime.fromISO(this.startTimer)).toFormat('hh:mm:ss');
      if (this.stopTimer >= this.astime) {
        this.beep(300, 500, 1, 'triangle');
        this.shadowRoot.getElementById('tooMuchTime').open();
        clearInterval(this.autoStop);
      }
    }, 1000); //fires every second
  }
  async loadTimeClassesModels(uid, userGroup) {
    // Short circuit if we are missing either of the required props
    if (uid == null || userGroup == null) return;

    // Otherwise, get classes from firebase
    const userTimeClasses = [];
    const companyRef = FirebaseWorker.ref(`photoheight/company_space/${userGroup}`);
    const projects = (await companyRef.child(`project_tracking/projects`).once('value')).val();
    for (const project of Object.values(projects ?? {})) {
      const userItems = project.users?.filter((x) => project.type != 'recurring' && (x.uid == uid || x.uid == '_all')) ?? [];
      userItems.forEach((userItem) => {
        userTimeClasses.push({
          name: project.name,
          labels: project.labels,
          part_time_secondary: userItem.part_time_secondary,
          description: userItem.description,
          start_date: userItem.start_date ? DateTime.fromISO(userItem.start_date) : null,
          end_date: userItem.end_date ? DateTime.fromISO(userItem.end_date) : null
        });
      });
    }
    this.userTimeClasses = userTimeClasses;

    // Get user data
    this.userData = (await FirebaseWorker.ref(`users/${userGroup}/${uid}`).once('value')).val();
    // If the user is a full-time employee, get overhead time classes
    if (this.userData?.employment?.employment_type == 'regular') {
      this.overheadTimeClasses = (await companyRef.child(`models/overhead_time_allocations`).once('value')).val();
      this.fullTimeEmployee = true;
    }
  }
}

customElements.define('stopwatch-widget', StopwatchWidget);
